import { Device } from "@capacitor/device"
import { oauthConfig } from "../OauthConfig"
import { AuthAxios } from "./AuthAxios"

const baseUrl = `${oauthConfig.authority}/api/center`

export const AuthGokartsApi = {
    connectToCenter: async (login: string, password: string) => {
        const response = await AuthAxios.post(`${baseUrl}/signin`, {
            device_id: (await Device.getId()).identifier,
            login: login,
            password: password
        })

        return response
    },

    /**
     * Fetches the users of the previously connected center via connectToCenter
     */
    getAuthenticatingCenter: async () => {
        const resp = AuthAxios.get(`${baseUrl}`)
        return resp
    },

    connectToCenterUser: async (login: string, password: string) => {
        const response = await AuthAxios.post(`${baseUrl}/user/signin`, {
            device_id: (await Device.getId()).identifier,
            login: login,
            password: password
        })

        return response
    },
}